/*
 * Copyright © 2023-2025 www.4bex.com
 *
 * Licensed under the www.4bex.com License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.4bex.com/license
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useState } from 'react';
import { Button, Card, Checkbox, Form, Input, Spin, Typography } from "antd";
import { LoadingOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import UseAuth from "../../hooks/UseAuth";
import useAxios from "../../hooks/axios";
import { useNavigate } from "react-router-dom";
import { API_URLS } from "../../configs/api.urls";
import GoogleAuth from "../google-auth/GoogleAuth";

import "./PartnerLogin.css";

const { Link, Text } = Typography;

const PartnerLoginPage = () => {
   const { setAuth } = UseAuth();
   const { loading, request } = useAxios();
   const [error, setError] = useState(null);
   const [form] = Form.useForm();

   const navigation = useNavigate();

   const handleSubmit = async (value) => {
      setError(null);
      const response = await request({
         url: API_URLS.LOGIN_URL,
         method: "POST",
         data: value,
      });
      if (!response.status) {
         return setError(response.error.message);
      }
      const { userId, userType, accessToken, refreshToken } = response;
      setAuth({ userId, userType, accessToken, refreshToken });
      form.resetFields();
      if (userType === "admin") {
         navigation("/admin/dashboard");
      } else {
         navigation("/partner/dashboard")
      }
   };
   return (
      <div style={{
         marginTop: "5vh"
      }}>
         <Card variant="borderless" className="login-page">
            <h2>
               <center>
                  Partner Login
               </center>
            </h2>
            <Form
               form={form}
               name="partner-login"
               initialValues={{ remember: true }}
               onFinish={handleSubmit}
            >
               <Form.Item
                  name="emailAddress"
                  rules={[
                     { required: true, message: "Please input your email address!" },
                     { type: "email", message: "Please enter a valid email address" },
                  ]}
               >
                  <Input prefix={<UserOutlined />} placeholder="Email Address" />
               </Form.Item>

               <Form.Item
                  name="password"
                  rules={[{ required: true, message: "Please input your password!" }]}
               >
                  <Input.Password prefix={<LockOutlined />} placeholder="Password" />
               </Form.Item>

               {error && (
                  <Form.Item>{error && <Text type="danger">{error}</Text>}</Form.Item>
               )}

               <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox>Remember me</Checkbox>
               </Form.Item>

               <Link href="#" style={{ float: "right" }}>
                  Forgot password
               </Link>

               <Form.Item className="login-btn">
                  <Button
                     type="primary"
                     htmlType="submit"
                     disabled={loading}
                     style={{ minWidth: "100px" }}
                  >
                     {loading ? (
                        <Spin indicator={<LoadingOutlined spin />} />
                     ) : (
                        "Log In"
                     )}
                  </Button>
               </Form.Item>
            </Form>
            <GoogleAuth
               onSuccessNavigation={(userType) => {
                  if (userType === "admin") {
                     navigation("/admin/dashboard");
                  } else {
                     navigation("/partner/dashboard");//because this is the partner login path navigation should be done to partner dashboard
                  }
               }}
            />

         </Card>
      </div>
   );
};

export default PartnerLoginPage;